



































import {Component, Vue, Watch} from 'vue-property-decorator';
import {ProductItem, SoftwareItem} from '@/types';
import {Getter} from 'vuex-class';
import router from '@/router';
import NewProductBar from '@/components/NewProductBar';
import {Header} from '@/components/Header';
import {ProductCategorySection} from '@/components/ProductCategorySection';
import {Footer} from '@/components/Footer';
import {HAS_REGISTERED_PRODUCT, MY_SENSEFLY} from '@/static/variables';
import {ProductType} from '@/constants/productTypes';

import {
  ProductCategoryAccessories as AccessoriesMobile,
  ProductCategoryDrones as DronesMobile,
  ProductCategorySoftware as SoftwareMobile,
} from '@/components/ProductCategoryMobile';

import {accessoriesHeaderItems, dronesHeaderItems, softwareHeaderItems,} from '@/static/uiElementsData';
import {getKeycloak} from "@/components/auth/keycloak";

@Component({
  components: {
    NewProductBar,
    Header,
    ProductCategorySection,
    DronesMobile,
    AccessoriesMobile,
    SoftwareMobile,
    Footer,
  },
})
export default class Home extends Vue {
  @Getter public uuid: string;
  @Getter public drones: ProductItem[];
  @Getter public accessories: ProductItem[];
  @Getter public software: SoftwareItem[];

  public dronesHeaderItems = dronesHeaderItems;
  public accessoriesHeaderItems = accessoriesHeaderItems;
  public softwareHeaderItems = softwareHeaderItems;
  public kc = getKeycloak();

  public beforeMount() {
    const $kc = this.kc;

    if (
        $kc
        && $kc.authenticated
        && !$kc.hasResourceRole(HAS_REGISTERED_PRODUCT, MY_SENSEFLY)
    ) {
      router.push({ name: 'Invitation' });
    }
  }

  public created() {
    this.$store.dispatch('fetchUserProfile');
  }

  @Watch('uuid')
  public onUuidChanged() {
    this.$store.dispatch('fetchProducts', ProductType.DRONE);
    this.$store.dispatch('fetchProducts', ProductType.CENTRAL_BODY);
    this.$store.dispatch('fetchProducts', ProductType.PAYLOAD);
    this.$store.dispatch('fetchProducts', ProductType.SPARE_PART);
    this.$store.dispatch('fetchProducts', ProductType.SOFTWARE);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home/Home.vue